import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'; // Update here: Switch -> Routes
import Login from './components/Login';
import Signup from './components/Signup';
import Homepage from './components/Homepage';
import SuccessPage from './components/SuccessPage';
import Adminhome from './components/Adminhome';
import RegisterBook from './components/RegisterBook';
import BooksList from './components/BookList';
import BuyBookPage from './components/BuyBookPage';
import ManageUsersPage from './components/ManageUsersPage';
import ListUsersPage from './components/ListUsersPage';
import EditBook from './components/EditBook';
import RentBookPage from './components/RentBookPage ';
import PurchaseHistoryPage from './components/PurchaseHistoryPage';
import RentalHistoryPage from './components/RentalHistoryPage';
import ProfileView from './components/ProfileView';
import ChangePassword from './components/ChangePassword';
import AdminRentalHistory from './components/AdminRentalHistory';
import AdminPurchaseHistory from './components/AdminPurchaseHistory';
import PaymentPage from './components/PaymentPage';
import About from './components/About';
import UserHome from './components/UserHome';


function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          {/* Updated Route for Login */}
          <Route path="/login" element={<Login />} />

          {/* Updated Route for Signup */}
          <Route path="/signup" element={<Signup />} />

          {/* Updated Route for Homepage */}
          <Route path="/" element={<Homepage />} />
          
          {/* Updated Route for Login */}
          <Route path="/login" element={<Login />} />

          {/* Updated Route for Login */}
          <Route path="/success" element={<SuccessPage />} />
          
          {/* Updated Route for Login */}
          <Route path="/admin" element={<Adminhome />} />
                  
          {/* Updated Route for Login */}
          <Route path="/register-book" element={<RegisterBook />} />
                          
          {/* Updated Route for Login */}
          <Route path="/view-books" element={<BooksList />} />

                                    
          {/* Updated Route for Login */}
          <Route path="/buy-book/:bookId" element={<BuyBookPage />} />
          
          {/* Updated Route for Login */}
          <Route path="/manage-users" element={<ManageUsersPage />} />

          {/* Updated Route for Login */}
          <Route path="/list-users" element={<ListUsersPage />} />


          <Route path="/edit-book/:id" element={<EditBook />} />

          <Route path="/buy/:bookId" element={<BuyBookPage />} />  {/* Add BuyBookPage route */}
          <Route path="/rent/:bookId" element={<RentBookPage />} />  {/* Add BuyBookPage route */}
          <Route path="/purchasehistory" element={<PurchaseHistoryPage />} />  {/* Add BuyBookPage route */}
          <Route path="/rentalhistory" element={<RentalHistoryPage />} />  {/* Add BuyBookPage route */}

          <Route path="/profile" element={<ProfileView />} />  {/* Add BuyBookPage route */}
          <Route path="/changepassword" element={<ChangePassword />} />  {/* Add BuyBookPage route */}
          <Route path="/adminrent" element={<AdminRentalHistory />} />  {/* Add BuyBookPage route */}
          <Route path="/adminpurchase" element={<AdminPurchaseHistory />} />  {/* Add BuyBookPage route */}
          <Route path="/pay/:rentalId" element={<PaymentPage />} />  {/* Add BuyBookPage route */}
          <Route path="/about" element={<About />} />
          <Route path="/userhome" element={<UserHome />} />


        </Routes>
      </div>
    </Router>
  );
}

export default App;
